// extracted by mini-css-extract-plugin
export default {"alphabet":"ICD10_alphabet__yDfE4","letter":"ICD10_letter__sr0EC","letterItems":"ICD10_letterItems__wYPRc"};